import React from 'react';
import { Modelling } from 'src/features/MM/components/templates/Modelling';
import { PageModelLayout } from '../../components/molecules/PageModelLayout';
import { FilterBar } from '../../components/organisms/FilterBar';
import { GenAIActionButtons } from 'src/components/molecules/GenAIActionButtons';

export const ModellingPage: React.FC = () => {
  return (
    <PageModelLayout
      filterBar={<FilterBar includeAggregation />}
      pageTitle="Modelling"
      extraButtons={<GenAIActionButtons />}>
      <Modelling />
    </PageModelLayout>
  );
};
